import React from 'react';
import clsx from 'clsx';

/**
 * Soft pill with a coloured dot. Use it for every status column so
 * "pending" looks the same on top-ups, repayments, clients and orders.
 * Extra props (and the ref) reach the <span>, so it can sit directly inside
 * a Tooltip or Popover.
 *
 * tone: default | primary | success | warning | danger | info | purple
 */
const StatusTag = React.forwardRef(
  ({ tone = 'default', children, dot = true, className, ...rest }, ref) => (
    <span ref={ref} className={clsx('status-tag', `status-tag--${tone}`, className)} {...rest}>
      {dot ? <span className="status-tag__dot" aria-hidden="true" /> : null}
      {children}
    </span>
  )
);

StatusTag.displayName = 'StatusTag';

/**
 * Build a renderer from a { value: { label, tone } } map:
 *   const renderStatus = statusRenderer(TOPUP_STATUS);
 *   render: (status) => renderStatus(status)
 */
export const statusRenderer = (map) => (value) => {
  const entry = map[value] || {};
  const label = entry.label || (value ? String(value).replace(/_/g, ' ') : '-');
  return <StatusTag tone={entry.tone || 'default'}>{label}</StatusTag>;
};

/** Tones for the status values shared by top-ups, repayments and clients. */
export const REVIEW_STATUS = {
  pending: { label: 'Pending', tone: 'warning' },
  processing: { label: 'Processing', tone: 'info' },
  approved: { label: 'Approved', tone: 'success' },
  rejected: { label: 'Rejected', tone: 'danger' },
  suspended: { label: 'Suspended', tone: 'default' },
  cancelled: { label: 'Cancelled', tone: 'default' },
};

export default StatusTag;
